export const NEARBY_TRANSFER_BETA_CODE = "beta-24";

export const isNearbyTransferBetaCode = (value = "") =>
  value.trim().toLowerCase() === NEARBY_TRANSFER_BETA_CODE;
